import { DisplayFormErrors, InputField, VerticalForm } from "melco-shared-logic";
import { Space } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EditLocaleStringsConfirmButton } from "../EditLocaleStringsConfirmButton";
import { FieldArray, useFormikContext } from "formik";


const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 50px;
`;


type DisplayEditLocaleStringsFormProps = {

};

export const DisplayEditLocaleStringsForm: React.FC<DisplayEditLocaleStringsFormProps> = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<any>();
  return (
    <>
      <div>
        <Right direction="vertical" size="small">
          <EditLocaleStringsConfirmButton ></EditLocaleStringsConfirmButton>
        </Right>

        <VerticalForm>
          <DisplayFormErrors />

          <InputField
            name="id"
            label={t("localestrings.actions.update.form.input.id")}
            readOnly
            disabled
          />
          <FieldArray
            name="strings"
            render={() => {
              return (
                <div>
                  {
                    values && values.strings && values.strings.map((string: any, index: any) => {
                      return (
                        <div>

                          <InputField
                            name={`strings.${index}.text`}
                            label={string.culture_code} />

                        </div>
                      )
                    })
                  }
                </div>
              )
            }} />

        </VerticalForm>
      </div>

    </>

  );
};
